/*
 * File: fascicle-edit.component.ts                                            *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 17:28:58                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';

import { FascicleService } from '../../../services/fascicle.service';
import { CatalogService } from '../../../services/catalog.service';
import { keyValue } from '../../../../tms-tools/interfaces/key-value';
import { PageService } from '../../../services/page.service';
import { PageTemplateService } from '../../../services/page-template.service';
import { Paginator } from '../../../../tms-tools/helpers/paginator';
import { AuthModel } from '@nousmedis/nm-guard-auth';
import { Fascicle, Page, PageTemplate } from '@nousmedis/cc-types';
import { User } from '@nousmedis/guard-types/dist/frontend';
import { FascicleSocketService } from '../../../services/fascicle-socket.service';
import { ProductService } from '../../../services/product.service';

import { GridLocked } from '../../../interfaces/grid-locked.interface';
import { TranslateService } from '@ngx-translate/core';
import { FascicleHistoryService } from '../../../services/fascicle-history.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-fascicle-edit',
  templateUrl: './fascicle-edit.component.html',
  styleUrls: ['./fascicle-edit.component.scss'],
  providers: [],
})
export class FascicleEditComponent implements OnInit, OnDestroy {
  @Input() idFascicle: string;
  @Input() idCatalog: string;

  loading: boolean = true;
  pageAnimClass = '';

  pageServiceSubscription = new Subscription();
  pageTemplateServiceSubscription = new Subscription();
  paginationIndexSubscription = new Subscription();
  private takeOverSubscription = new Subscription();
  private wasForceUnblocked = false;
  private didBlockFascicle = false;
  private forceNavigateSub = new Subscription();
  allPageTemplates: PageTemplate[] = [];
  currentPageTemplate: PageTemplate = null;
  fascicle: Fascicle;
  pages: Page[] = [];
  visiblePages: Page[] = [];
  gPage: Paginator;
  toolbarClass: string = 'disable-toolbar';
  currentPageIndex: number[] = null;
  currentComboPageIndex: any = null;
  currentNumberPages: number[] = null;
  /**Initial data */
  paginatorData = {
    totalPages: 0, //  Changes when page added or remove
    size: 1, //  Qty of pages viewed
    index: 0,
  };

  /**For style pourpouses */
  basePageColumn: number = 80;
  sizePage: number;

  productFilter: keyValue[] = [];
  gridLocked: GridLocked = { index: -1, locked: true };

  gridLocked$: Subject<GridLocked> = new Subject<GridLocked>();

  user: User;
  historyPanelVisible = false;

  whellLastTime: number = 0;

  constructor (
    private auth: AuthModel,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private fascicleService: FascicleService,
    private fascicleSockets: FascicleSocketService,
    private pageService: PageService,
    private pageTemplateService: PageTemplateService,
    private productService: ProductService,
    private catalogService: CatalogService,
    private historyService: FascicleHistoryService,
    private messageService: MessageService,
  ) {
    this.user = this.auth.getCurrentUser();
  }

  ngOnInit() {
    this.productService.offsetSearch = 0;
    //TODO: DEBUG THIS
    this.route.paramMap.subscribe((params) => {
      this.idCatalog = params.get('idCatalog')!;
      this.idFascicle = params.get('id')!;

      // this.loadData();
      this.catalogService.setCurrentCatalog(this.idCatalog);
      this.catalogService.setCurrentCatalog(this.idCatalog);
      this.loadPageTemplates();
      this.listenPageService();
      this.whellLastTime = Date.now();

      this.takeOverSubscription = this.fascicleSockets.fascicleToTakeOver.subscribe((data) => {
        if (data.fascicleId === this.idFascicle && data.userId === this.user.id) {
          this.router.navigate(['/catalog', this.idCatalog, 'fascicles']);
        }
      });

      this.forceNavigateSub = this.fascicleSockets.forceNavigate.subscribe((data) => {
        if (data.fascicleId === this.idFascicle) {
          this.wasForceUnblocked = true;
          this.router.navigate(['/catalog', this.idCatalog, 'fascicles']);
        }
      });
    });
  }

  listenPageService() {
    this.pageServiceSubscription = this.pageService.pagesSubject.subscribe(
      (pages) => {
        this.pages = pages;
        this.paginatorData.totalPages = pages.length;
        this.loadNumberPages();
        if (this.gPage) {
          // console.log("Si que existe gPage")
          this.gPage.reload(this.pages.map((p) => p.pageNumber));
          this.gPage.reloadCombo();
          console.log(
            'this.pageService.deletedPage',
            this.pageService.deletedPage
          );
          console.log(
            'this.pageService.indexPreviousDelete',
            this.pageService.indexPreviousDelete
          );

          if (
            this.pageService.deletedPage &&
            this.pageService.indexPreviousDelete != -1
          ) {
            this.pageService.deletedPage = false;
            if (
              this.pageService.indexPreviousDelete <=
              this.gPage.pagination.length
            )
              this.gPage.goToIndex(this.pageService.indexPreviousDelete);
            else this.gPage.goToLast();
            this.pageService.indexPreviousDelete = -1;
          } else {
            this.gPage.goToPage(this.pageService.goToIndex);
          }

          //this.gPage.goToLast();
        }
      }
    );
  }

  loadPageTemplates() {
    this.pageTemplateServiceSubscription = this.pageTemplateService
      .getTemplates()
      .subscribe(async (pageTemplates) => {
        this.pageService.setPageTemplates(pageTemplates);
        this.allPageTemplates = pageTemplates;
        this.loadFascicle();
      });
  }

  loadPagination() {
    this.gPage = new Paginator(
      this.pages.map((p) => p.pageNumber),
      0,
      2
    );
    this.paginatorData.totalPages = this.gPage.totalPages;
    this.currentPageIndex = this.gPage.currentPage();

    this.paginationIndexSubscription = this.gPage._index.subscribe((index) => {
      this.currentPageIndex = index;
      this.currentComboPageIndex = this.gPage.getComboKeyFromValue();
    });
    this.gPage.getComboPagination();
    this.currentComboPageIndex = this.gPage.getComboKeyFromValue();
    this.loading = false;
  }

  loadNumberPages() {
    this.currentNumberPages = [];
    this.pages.forEach((page) => {
      this.currentNumberPages.push(page.pageNumber);
    });
  }
  /**
   * 1.- Carga el fasciculo
   * 2.- Por cada página carga las celdas.
   */

  loadFascicle() {
    this.loading = true;
    this.fascicleService
      .get(this.idCatalog, this.idFascicle)
      .subscribe((fascicle) => {
        this.fascicle = fascicle;
        const rawBlockedBy = (fascicle as any).blockedBy;
        const blockedById = typeof rawBlockedBy === 'object' ? (rawBlockedBy?.id ?? rawBlockedBy?._id) : rawBlockedBy;
        if (fascicle.blocked && blockedById && blockedById !== this.user.id) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('FASCICLE.LOCKED_BY'),
            detail: typeof rawBlockedBy === 'object' ? rawBlockedBy.name ?? blockedById : blockedById,
            key: 'root-msg',
            life: 5000,
          });
          this.router.navigate(['/catalog', this.idCatalog, 'fascicles']);
          return;
        }
        this.pageService.idCatalog = this.idCatalog;
        this.pageService.idFasiclce = this.idFascicle;
        this.historyService.loadHistory(this.idCatalog, this.idFascicle);
        this.fascicleService.block(this.idCatalog, this.idFascicle).subscribe();
        this.didBlockFascicle = true;
        this.fascicleSockets.sendChanges(
          this.idCatalog,
          this.idFascicle,
          this.user.id,
          true
        );
        // let that = this;
        setTimeout(function () {
          // that.fascicleSockets.sendChanges();
        }, 1000);
        this.setFilters();
        this.fascicleService.setToolbarData(
          this.idCatalog,
          this.idFascicle,
          this.productFilter
        );
        if (!this.fascicle.pages) {
          this.pageService.goToIndex = this.pages.length;
          this.pageService.addPage(this.user.id);
        } else {
          this.pageService.setPages(fascicle.pages);
        }

        this.loadPagination();
      });
  }

  /**
   * Uso del wheel del ratón para cambiar de página
   */

  // Función throttle
  throttle(func: any, delay: number) {
    let that = this;
    return function (...args: any) {
      const ahora = Date.now();
      if (ahora - that.whellLastTime >= delay) {
        that.whellLastTime = ahora;
        func(...args);
      }
    };
  }

  changePages(event: WheelEvent) {
    const delay = 500;
    if (Date.now() - this.whellLastTime < delay) return;
    if (event.deltaY > 0) {
      if (!this.gPage.nextIsDisabled()) this.navigateNext();
      this.whellLastTime = Date.now();
    } else {
      if (!this.gPage.previousIsDisabled()) this.navigatePrev();
      this.whellLastTime = Date.now();
    }
  }

  getPageTemplate(pageIndex: number) {
    return this.pageService.getPageTemplate(pageIndex);
  }

  addTheFirstPage() {
    this.pageService.addPage(this.user.id);
  }

  setFilters() {
    if (this.fascicle) {
      if (this.fascicle.categories)
        this.productFilter.push({
          id: 'categories',
          value: this.fascicle.categories,
        });
      if (this.fascicle.tags)
        this.productFilter.push({ id: 'tags', value: this.fascicle.tags });
    }
  }

  /**
   * Pages behaviour
   */

  getPageSize() {
    this.sizePage = this.basePageColumn / this.paginatorData.size;
  }

  nextDisabled() {
    return this.paginatorData.index >= this.paginatorData.totalPages - 1;
  }

  backDisabled() {
    return this.paginatorData.index <= 0;
  }

  async checkLocked(gridLocked: GridLocked) {
    if (gridLocked.locked) {
      await this.pageService.savePages();
      this.fascicleService.lockButtons.next(gridLocked);
    }
    else{
      this.fascicleService.lockButtons.next(gridLocked);
    }
    this.gridLocked = gridLocked;
  }

  changeFormat(format: PageTemplate, pageIndex: number) {
    this.pageService.setGrid(pageIndex, format, this.user.id);
  }

  pageIsOdd(pageN: number) {
    if (this.pages && this.pages[pageN]) {
      this.pages[pageN].pageNumber;
      return this.pages[pageN].pageNumber % 2 == 1;
    }
    return true;
  }

  addPage() {
    this.pageService.goToIndex = this.pages.length;
    this.pageService.addPage(this.user.id);
  }

  navigateNext(): void {
    if (this.pageAnimClass || this.gPage.index === this.gPage.pagination.length - 1) return;
    this.pageAnimClass = 'page-exit-left';
    setTimeout(() => {
      this.gPage.next();
      this.pageAnimClass = 'page-enter-right';
      setTimeout(() => { this.pageAnimClass = ''; }, 220);
    }, 160);
  }

  navigatePrev(): void {
    if (this.pageAnimClass || this.gPage.index === 0) return;
    this.pageAnimClass = 'page-exit-right';
    setTimeout(() => {
      this.gPage.previous();
      this.pageAnimClass = 'page-enter-left';
      setTimeout(() => { this.pageAnimClass = ''; }, 220);
    }, 160);
  }

  navigateToIndex(index: number): void {
    if (this.pageAnimClass || index === this.gPage.index) return;
    const goingForward = index > this.gPage.index;
    this.pageAnimClass = goingForward ? 'page-exit-left' : 'page-exit-right';
    setTimeout(() => {
      this.gPage.goToIndex(index);
      this.pageAnimClass = goingForward ? 'page-enter-right' : 'page-enter-left';
      setTimeout(() => { this.pageAnimClass = ''; }, 220);
    }, 160);
  }

  handlePaginatorNavigate(req: {action: 'prev' | 'next' | 'first' | 'last' | 'index', index?: number}): void {
    switch (req.action) {
      case 'prev':  this.navigatePrev(); break;
      case 'next':  this.navigateNext(); break;
      case 'first': this.navigateToIndex(0); break;
      case 'last':  this.navigateToIndex(this.gPage.pagination.length - 1); break;
      case 'index': this.navigateToIndex(req.index); break;
    }
  }

  /**
   * End Pages behaviour
   */
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    if (this.didBlockFascicle && !this.wasForceUnblocked) {
      this.fascicleService.unblock(this.idCatalog, this.idFascicle);
      this.fascicleSockets.sendChanges(
        this.idCatalog,
        this.idFascicle,
        this.user.id,
        false
      );
    }
    this.pageServiceSubscription.unsubscribe();
    this.pageTemplateServiceSubscription.unsubscribe();
    this.paginationIndexSubscription.unsubscribe();
    this.takeOverSubscription.unsubscribe();
    this.forceNavigateSub.unsubscribe();
    this.catalogService.setCurrentCatalog(this.idCatalog);
  }
}
